export const API_REFERRAL_NUMBER_SUCCESS = "API_REFERRAL_NUMBER_SUCCESS";
export const API_REFERRAL_NUMBER_FAIL = "API_REFERRAL_NUMBER_FAIL";
export const GET_REFERRAL_NUMBER = "GET_REFERRAL_NUMBER";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const RESET_REFERRAL_STATE = "RESET_REFERRAL_STATE";